import axiosClient from "./axiosClient";

// --- Social Media Link APIs ---
export const getSocialMediaLinks = () => axiosClient.get("/social-links");
export const createSocialMediaLink = (linkData) => axiosClient.post("/social-links", linkData);
export const updateSocialMediaLink = (id, linkData) => axiosClient.put(`/social-links/${id}`, linkData);
export const deleteSocialMediaLink = (id) => axiosClient.delete(`/social-links/${id}`);
